import { render, staticRenderFns } from "./SuccessNotification.vue?vue&type=template&id=0c95b553&scoped=true"
import script from "./SuccessNotification.vue?vue&type=script&lang=js"
export * from "./SuccessNotification.vue?vue&type=script&lang=js"
import style0 from "./SuccessNotification.vue?vue&type=style&index=0&id=0c95b553&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c95b553",
  null
  
)

export default component.exports